// @generated by protoc-gen-es-ns v0.0.0 with parameter "target=ts"
// @generated from file kikoff_canada/protobuf/models/payments/payment_method.proto (package kikoff_canada.protobuf.models.payments, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message kikoff_canada.protobuf.models.payments.PaymentMethod
 */
export class PaymentMethod extends Message<PaymentMethod> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: kikoff_canada.protobuf.models.payments.PaymentMethod.Type type = 2;
   */
  type = PaymentMethod.Type.UNKNOWN;

  /**
   * @generated from field: repeated kikoff_canada.protobuf.models.payments.PaymentMethod.AffiliatedAccount affiliated_accounts = 3;
   */
  affiliatedAccounts: PaymentMethod.AffiliatedAccount[] = [];

  /**
   * @generated from oneof kikoff_canada.protobuf.models.payments.PaymentMethod.details
   */
  details: {
    /**
     * @generated from field: kikoff_canada.protobuf.models.payments.PaymentMethod.CardDetails card_details = 4;
     */
    value: PaymentMethod.CardDetails;
    case: "cardDetails";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<PaymentMethod>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.models.payments.PaymentMethod";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(PaymentMethod.Type) },
    { no: 3, name: "affiliated_accounts", kind: "message", T: PaymentMethod.AffiliatedAccount, repeated: true },
    { no: 4, name: "card_details", kind: "message", T: PaymentMethod.CardDetails, oneof: "details" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentMethod {
    return new PaymentMethod().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentMethod {
    return new PaymentMethod().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentMethod {
    return new PaymentMethod().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentMethod | PlainMessage<PaymentMethod> | undefined, b: PaymentMethod | PlainMessage<PaymentMethod> | undefined): boolean {
    return proto3.util.equals(PaymentMethod, a, b);
  }

  static _enums: {
    Type: typeof PaymentMethod.Type,
  };
}

export namespace PaymentMethod {
  /**
   * @generated from enum kikoff_canada.protobuf.models.payments.PaymentMethod.Type
   */
  export enum Type {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: CARD = 1;
     */
    CARD = 1,
  }
  // Retrieve enum metadata with: proto3.getEnumType(PaymentMethod.Type)
  proto3.util.setEnumType(PaymentMethod.Type, "kikoff_canada.protobuf.models.payments.PaymentMethod.Type", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "CARD" },
  ]);
}

export namespace PaymentMethod {
  /**
   * @generated from message kikoff_canada.protobuf.models.payments.PaymentMethod.AffiliatedAccount
   */
  export class AffiliatedAccount extends Message<PaymentMethod.AffiliatedAccount> {
    /**
     * @generated from field: kikoff_canada.protobuf.models.payments.PaymentMethod.AffiliatedAccount.Type type = 1;
     */
    type = PaymentMethod.AffiliatedAccount.Type.UNKNOWN;

    /**
     * @generated from field: string id = 2;
     */
    id = "";

    /**
     * @generated from field: kikoff_canada.protobuf.models.payments.PaymentMethod.AffiliatedAccount.Usage usage = 3;
     */
    usage = PaymentMethod.AffiliatedAccount.Usage.NONE;

    constructor(data?: PartialMessage<PaymentMethod.AffiliatedAccount>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.payments.PaymentMethod.AffiliatedAccount";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(PaymentMethod.AffiliatedAccount.Type) },
      { no: 2, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 3, name: "usage", kind: "enum", T: proto3.getEnumType(PaymentMethod.AffiliatedAccount.Usage) },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentMethod.AffiliatedAccount {
      return new PaymentMethod.AffiliatedAccount().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentMethod.AffiliatedAccount {
      return new PaymentMethod.AffiliatedAccount().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentMethod.AffiliatedAccount {
      return new PaymentMethod.AffiliatedAccount().fromJsonString(jsonString, options);
    }

    static equals(a: PaymentMethod.AffiliatedAccount | PlainMessage<PaymentMethod.AffiliatedAccount> | undefined, b: PaymentMethod.AffiliatedAccount | PlainMessage<PaymentMethod.AffiliatedAccount> | undefined): boolean {
      return proto3.util.equals(PaymentMethod.AffiliatedAccount, a, b);
    }

    static _enums: {
      Type: typeof PaymentMethod.AffiliatedAccount.Type,
      Usage: typeof PaymentMethod.AffiliatedAccount.Usage,
    };
  }
}

export namespace PaymentMethod.AffiliatedAccount {
  /**
   * @generated from enum kikoff_canada.protobuf.models.payments.PaymentMethod.AffiliatedAccount.Type
   */
  export enum Type {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: CREDIT_LINE = 1;
     */
    CREDIT_LINE = 1,
  }
  // Retrieve enum metadata with: proto3.getEnumType(PaymentMethod.AffiliatedAccount.Type)
  proto3.util.setEnumType(PaymentMethod.AffiliatedAccount.Type, "kikoff_canada.protobuf.models.payments.PaymentMethod.AffiliatedAccount.Type", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "CREDIT_LINE" },
  ]);
}

export namespace PaymentMethod.AffiliatedAccount {
  /**
   * @generated from enum kikoff_canada.protobuf.models.payments.PaymentMethod.AffiliatedAccount.Usage
   */
  export enum Usage {
    /**
     * @generated from enum value: NONE = 0;
     */
    NONE = 0,

    /**
     * @generated from enum value: AUTOPAY = 1;
     */
    AUTOPAY = 1,
  }
  // Retrieve enum metadata with: proto3.getEnumType(PaymentMethod.AffiliatedAccount.Usage)
  proto3.util.setEnumType(PaymentMethod.AffiliatedAccount.Usage, "kikoff_canada.protobuf.models.payments.PaymentMethod.AffiliatedAccount.Usage", [
    { no: 0, name: "NONE" },
    { no: 1, name: "AUTOPAY" },
  ]);
}

export namespace PaymentMethod {
  /**
   * @generated from message kikoff_canada.protobuf.models.payments.PaymentMethod.CardDetails
   */
  export class CardDetails extends Message<PaymentMethod.CardDetails> {
    /**
     * @generated from field: kikoff_canada.protobuf.models.payments.PaymentMethod.CardDetails.Type type = 1;
     */
    type = PaymentMethod.CardDetails.Type.UNKNOWN;

    /**
     * @generated from field: string brand = 2;
     */
    brand = "";

    /**
     * @generated from field: string last_four = 3;
     */
    lastFour = "";

    constructor(data?: PartialMessage<PaymentMethod.CardDetails>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.payments.PaymentMethod.CardDetails";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(PaymentMethod.CardDetails.Type) },
      { no: 2, name: "brand", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 3, name: "last_four", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentMethod.CardDetails {
      return new PaymentMethod.CardDetails().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentMethod.CardDetails {
      return new PaymentMethod.CardDetails().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentMethod.CardDetails {
      return new PaymentMethod.CardDetails().fromJsonString(jsonString, options);
    }

    static equals(a: PaymentMethod.CardDetails | PlainMessage<PaymentMethod.CardDetails> | undefined, b: PaymentMethod.CardDetails | PlainMessage<PaymentMethod.CardDetails> | undefined): boolean {
      return proto3.util.equals(PaymentMethod.CardDetails, a, b);
    }

    static _enums: {
      Type: typeof PaymentMethod.CardDetails.Type,
    };
  }
}

export namespace PaymentMethod.CardDetails {
  /**
   * @generated from enum kikoff_canada.protobuf.models.payments.PaymentMethod.CardDetails.Type
   */
  export enum Type {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: CREDIT = 1;
     */
    CREDIT = 1,

    /**
     * @generated from enum value: DEBIT = 2;
     */
    DEBIT = 2,

    /**
     * @generated from enum value: PREPAID = 3;
     */
    PREPAID = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(PaymentMethod.CardDetails.Type)
  proto3.util.setEnumType(PaymentMethod.CardDetails.Type, "kikoff_canada.protobuf.models.payments.PaymentMethod.CardDetails.Type", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "CREDIT" },
    { no: 2, name: "DEBIT" },
    { no: 3, name: "PREPAID" },
  ]);
}

